export default {
  title: "Active languages in Excoino",
  farsi: "Persian",
  english: "English",
  arabic: "Arabic",
  confirmBtn: "Confirm"
};
